import axios from 'axios'


export const baseApi=axios.create({baseURL:'https://app.al-fakhm1card.com/api/v1',withCredentials:true})
